import { m } from 'framer-motion';
// next
import { styled } from '@mui/material/styles';
// @mui
import { Container, Typography } from '@mui/material';
// layouts
import Layout from '@common/layouts';
// components
import Page from '@common/components/Page';
import { MotionContainer, varBounce } from '@common/components/animate';
// assets
import { SeverErrorIllustration } from '@common/assets';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

PageNoMobile.getLayout = function getLayout(page: React.ReactElement) {
  return <Layout variant="logoOnly">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function PageNoMobile() {
  return (
    <Page title="Device Compatibility Error">
      <Container component={MotionContainer}>
        <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
          <m.div variants={varBounce().in}>
            <Typography variant="h3" paragraph>
              Sorry! Dash is not compatible with your device.
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography sx={{ color: 'text.secondary' }}>
              Please use a desktop or laptop computer to access Dash.
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <SeverErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
          </m.div>
        </ContentStyle>
      </Container>
    </Page>
  );
}
